var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBamboo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-20 0 296 296",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.015868%",
    y1: "-98.2986767%",
    x2: "50.015868%",
    y2: "38.2167612%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2684FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0157183%",
    y1: "0.763358779%",
    x2: "50.0157183%",
    y2: "138.581425%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2684FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M247.205647,167.895843 L185.805804,167.895843 C181.801013,167.850569 178.374932,170.762737 177.774431,174.72251 C174.286852,199.674786 152.933797,218.234463 127.73898,218.212392 L144.363922,294.14902 C204.596151,286.279791 250.95582,237.082461 255.23702,176.489412 C255.393206,174.263743 254.616512,172.073407 253.093078,170.443333 C251.569644,168.813259 249.436782,167.89037 247.205647,167.895843 Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.950588,165.968314 L229.295686,90.0316863 C231.024443,88.5070664 232.014805,86.3131655 232.014805,84.0081569 C232.014805,81.7031483 231.024443,79.5092473 229.295686,77.9846275 L140.950588,1.92752941 C138.566824,-0.0845072949 135.23364,-0.534256453 132.40186,0.774042915 C129.570081,2.08234228 127.752005,4.91200514 127.73898,8.03137255 L127.73898,159.864471 C127.752005,162.983838 129.570081,165.813501 132.40186,167.1218 C135.23364,168.4301 138.566824,167.98035 140.950588,165.968314 Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.20470588,184.480627 C9.65441843,247.916976 63.7423708,295.31045 127.73898,295.353725 L127.73898,218.212392 C99.9303626,218.212471 77.3683826,195.704382 77.3019608,167.895843 L1.20470588,184.480627 Z",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,166.691137 L0,167.895843 L77.3019608,167.895843 C77.3683826,140.087305 99.9303626,117.579215 127.73898,117.579294 L111.154196,41.6426667 C48.1449965,49.8531147 0.766538803,103.15388 0,166.691137",
    fill: "url(#linearGradient-2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBamboo);
export default __webpack_public_path__ + "static/media/bamboo.c09ad3fb5ce769233f9bb039057ddf95.svg";
export { ForwardRef as ReactComponent };